import { getRatings } from "./utils/api";
import tableColumns from "./components/tableColumns";
import { excelHeaderCellsName } from "./utils/options";
import {
  Breadcrumb,
  DownloadExcel,
  ErrorAlert,
  PageHero,
  StarIcon,
  TableRowsPerPage,
  useFetchData,
} from "@";
import { DataTable } from "@/shared/components/tanstackTable";

const Index = () => {
  const links = [{ name: "التقيمات", link: "" }];

  const { data, isLoading, error, pg, fetchData, updatePg } = useFetchData({
    fun: getRatings,
  });

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      <main className="table-card relative">
        <PageHero
          eyebrow="المتبرعين / التقييمات"
          title="التقيمات"
          count={pg.rows}
          icon={StarIcon}
          hideCount={isLoading}
        >
          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size })}
          />
          <DownloadExcel
            headerCellsName={excelHeaderCellsName}
            fetch={getRatings}
            length={data?.length}
            pageSize=""
          />
        </PageHero>

        <DataTable
          data={data}
          columns={tableColumns}
          isLoading={isLoading}
          pagination={pg}
          onPageChange={(page) => updatePg({ page })}
          onPageSizeChange={(size) => updatePg({ size, page: 1 })}
        />
      </main>
    </>
  );
};

export default Index;
